import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SupplierTable = ({ suppliers, onEdit, onDelete, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'excellent':
        return 'bg-success/10 text-success';
      case 'good':
        return 'bg-primary/10 text-primary';
      case 'warning':
        return 'bg-warning/10 text-warning';
      case 'critical':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'excellent':
        return 'CheckCircle2';
      case 'good':
        return 'CheckCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'critical':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-4 px-4 text-sm font-semibold text-foreground">Nama Peternak</th>
            <th className="text-left py-4 px-4 text-sm font-semibold text-foreground">Lokasi</th>
            <th className="text-right py-4 px-4 text-sm font-semibold text-foreground">Volume Harian</th>
            <th className="text-center py-4 px-4 text-sm font-semibold text-foreground">Kualitas</th>
            <th className="text-center py-4 px-4 text-sm font-semibold text-foreground">Status Pembayaran</th>
            <th className="text-center py-4 px-4 text-sm font-semibold text-foreground">Konsistensi</th>
            <th className="text-center py-4 px-4 text-sm font-semibold text-foreground">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {suppliers?.map((supplier) => (
            <tr key={supplier?.id} className="border-b border-border hover:bg-muted/50 transition-colors">
              <td className="py-4 px-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name="User" size={20} color="var(--color-primary)" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground">{supplier?.name}</p>
                    <p className="text-xs text-muted-foreground">{supplier?.farmerId}</p>
                  </div>
                </div>
              </td>
              <td className="py-4 px-4">
                <div className="flex items-center gap-2">
                  <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
                  <span className="text-sm text-foreground">{supplier?.location}</span>
                </div>
              </td>
              <td className="py-4 px-4 text-right">
                <p className="text-sm font-medium text-foreground data-text">{supplier?.dailyVolume} L</p>
                <p className="text-xs text-muted-foreground">per hari</p>
              </td>
              <td className="py-4 px-4">
                <div className="flex justify-center">
                  <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg ${getStatusColor(supplier?.qualityStatus)}`}>
                    <Icon name={getStatusIcon(supplier?.qualityStatus)} size={14} />
                    <span className="text-xs font-medium">{supplier?.qualityRating}%</span>
                  </div>
                </div>
              </td>
              <td className="py-4 px-4">
                <div className="flex justify-center">
                  <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg ${getStatusColor(supplier?.paymentStatus)}`}>
                    <Icon name={supplier?.paymentStatus === 'excellent' ? 'CheckCircle2' : 'Clock'} size={14} />
                    <span className="text-xs font-medium capitalize">{supplier?.paymentLabel}</span>
                  </div>
                </div>
              </td>
              <td className="py-4 px-4">
                <div className="flex justify-center">
                  <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg ${getStatusColor(supplier?.consistencyStatus)}`}>
                    <Icon name={getStatusIcon(supplier?.consistencyStatus)} size={14} />
                    <span className="text-xs font-medium">{supplier?.consistencyScore}%</span>
                  </div>
                </div>
              </td>
              <td className="py-4 px-4">
                <div className="flex items-center justify-center gap-2">
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onViewDetails(supplier)}
                    iconName="Eye"
                    iconSize={18}
                  >
                    <span className="sr-only">Lihat Detail</span>
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onEdit(supplier)}
                    iconName="Edit"
                    iconSize={18}
                  >
                    <span className="sr-only">Edit</span>
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onDelete(supplier?.id)}
                    iconName="Trash2"
                    iconSize={18}
                  >
                    <span className="sr-only">Hapus</span>
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SupplierTable;